import PhoenixDocCard from 'components/base/PhoenixDocCard';
import DocPageHeader from 'components/docs/DocPageHeader';
import DocPagesLayout from 'layouts/DocPagesLayout';
import { Col, Row } from 'react-bootstrap';
import risk from 'assets/img/spot-illustrations/risk.png';
import risk2 from 'assets/img/spot-illustrations/risk2.png';
import RiskCategoryList from './RiskCategoryList';
import RiskElementList from './RiskElementList';

const RiskManagement = () => {
  return (
    <div>
      <DocPageHeader title="Risk Management" />
      <DocPagesLayout>
        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Risk Categories"
            noPreview
            className="pb-3 pt-3"
          >
            <Row>
              <Col className="d-flex justify-content-between align-items-center">
                <div>
                  <p className="mb-0">
                    Risk categories help organize and classify potential issues
                    that may arise during customer interactions. Each category
                    groups related risk elements for better management and
                    analysis.
                  </p>
                </div>
              </Col>
              <Col xs="auto" className="order-xxl-2">
                <div className="x-6">
                  <img src={risk2} alt="" />
                </div>
              </Col>
            </Row>
          </PhoenixDocCard.Header>
          <PhoenixDocCard.Body>
            <div className="px-4">
              <RiskCategoryList />
            </div>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>

        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Risk Elements"
            noPreview
            className="pb-3 pt-3"
          >
            <Row>
              <Col className="d-flex justify-content-between align-items-center">
                <div>
                  <p className="mb-0">
                    Risk elements are specific behaviors or situations that the
                    AI system detects during call analysis. Each element has an
                    AI prompt that guides the detection process and assigns a
                    severity level from 1 to 5.
                  </p>
                </div>
              </Col>
              <Col xs="auto" className="order-xxl-2">
                <div className="x-6">
                  <img src={risk} alt="" />
                </div>
              </Col>
            </Row>
          </PhoenixDocCard.Header>
          <PhoenixDocCard.Body>
            <div className="px-4">
              <RiskElementList />
            </div>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
      </DocPagesLayout>
    </div>
  );
};

export default RiskManagement;
